import { FONT_DATA, FONT_WEIGHT } from "consts/font/font";
import { THEME_COLOR } from "consts/theme/theme";
import { useEffect, useState } from "react";
import useDarkModeStore from "stores/useDarkModeStore";

export const useBootstrapStyle = () => {
  const { isDarkMode } = useDarkModeStore();

  const [isReady, setIsReady] = useState(false);

  /**
   * 테마 컬러 변경 감지 및 적용
   */
  useEffect(() => {
    const root = document.documentElement;

    for (let key in THEME_COLOR) {
      root.style.setProperty(
        key,
        THEME_COLOR[key as keyof typeof THEME_COLOR][
          isDarkMode ? "dark" : "light"
        ]
      );
    }
  }, [isDarkMode]);

  /**
   * 폰트 로드 (Bootstrap)
   */
  useEffect(() => {
    const style = document.createElement("style");
    style.type = "text/css";

    FONT_DATA.forEach((font) => {
      font.weights.forEach((weight) => {
        const fontFace = `
          @font-face {
            font-family: '${font.name}';
            src: url('/assets/font/${font.key}/${font.key}-${weight}.${font.extension}')
              format('truetype');
            font-weight: ${FONT_WEIGHT[weight]};
            font-style: ${weight.includes("Italic") ? "italic" : "normal"};
          }
        `;

        style.appendChild(document.createTextNode(fontFace));
      });
    });

    document.head.appendChild(style);

    // 폰트 적용 완료되면 즉시 ready 처리
    setIsReady(true);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return isReady;
};
